import axiosInstance from "../axiosInstance";

export const POSTLogin = async (usuarioPayload) => {
  try {
    const response = await axiosInstance.post(
      `${process.env.REACT_APP_WMS_BASE_URL}/autenticacion/login`,
      usuarioPayload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    // Errores de red u otros
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default POSTLogin;
